import { bankMovementsHistory as getAllCashFlowHistory } from "@/api/financialEntity";

export default {
    state: () => ({
        chartParams: {},
        cashFlowData: [],
    }),
    mutations: {
        SET_CASH_FLOW_DATA: (state, payload) => {
            state.cashFlowData = payload;
        },
        SET_CHART_PARAMS: (state, payload) => {
            // Ojo histórico: escribía `charParams` (typo) — una key no
            // declarada (no reactiva en Vue 2) mientras `chartParams` quedaba
            // muerta.
            state.chartParams = payload;
        },
    },
    actions: {
        getCashFlowHistory({ state, commit }, payload) {
            commit("SET_CHART_PARAMS", payload);
            return new Promise((resolve, reject) => {
                getAllCashFlowHistory({ params: state.chartParams })
                    .then((response) => {
                        commit("SET_CASH_FLOW_DATA", response.data);
                        resolve(true);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
    },
    getters: {},
    namespaced: true,
};
